/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage, Spinner } from 'sarsaparilla';

import MobileWhichPassContainer from '../src/containers/MobileWhichPassContainer';
import ReservationPageWrapper from '../src/containers/ReservationPageWrapper';
import PassTypePageWrapper from '../src/containers/PassTypePageWrapper';
import PassLandingPage from '../src/components/PassLandingPage';
import InteragencyAnnualPass from '../src/containers/InteragencyAnnualPass';
import NewPassLandingPage from '../src/components/NewPassLandingPage';
import routesArray from './routesArray';

const Components = {
    ReservationPageWrapper,
    PassTypePageWrapper,
    InteragencyAnnualPass,
    PassLandingPage,
    NewPassLandingPage,
    MobileWhichPassContainer,
};

export default function makeSwitchRoutes(releaseIapPassLandingPage) {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];
        if (route.path === '/pass') {
            return (
                <Route
                    key={route.path}
                    path={route.path}
                    element={
                        releaseIapPassLandingPage === undefined ? (
                            <Spinner />
                        ) : releaseIapPassLandingPage === false ? (
                            <PassLandingPage />
                        ) : (
                            <NewPassLandingPage />
                        )
                    }
                />
            );
        }

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
